import { IPeriodsByService } from '../../../../../redux/reducers';
import { ITermSchema } from '../../../../../repositories/billing-tariffs/v1/publish-terms';
import { getPeriodId } from '../getPeriodId';
import { getServiceId } from '../../../../../utils/publishTerms';
import { mapPeriods } from './mapPeriods';

export function mapPeriodsByService(terms: ITermSchema[]): IPeriodsByService {
  return terms.reduce((acc, term) => {
    const serviceId = getServiceId(term.services);
    const rawPeriods = term.periods;

    if (!rawPeriods) {
      acc[serviceId] = { periodIds: [], periods: {} };

      return acc;
    }

    acc[serviceId] = {
      periodIds: rawPeriods.map(getPeriodId),
      periods: mapPeriods(rawPeriods),
    };

    return acc;
  }, {} as IPeriodsByService);
}
